<template>
  <div id="venues">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <a href="javascript:;" class="navbar-nav-link" @click="isFilterEnabled = !isFilterEnabled">
              {{ this.$t('event.components.participants.navbar.filterRecord') }}
              <i class="fas fa-search ml-1" :class="$store.state.surveys.filter.searchTerm != null && $store.state.surveys.filter.searchTerm != '' ? 'animate__animated animate__pulse animate__infinite text-info' : ''"></i>
            </a>
          </li>

          <li class="nav-item">
            <a
              href="javascript:;"
              class="navbar-nav-link"
              @click="
                updateForm = null;
                modalVisible = true;
              "
            >{{ this.$t('event.components.participants.navbar.add') }}
              <i class="icon-plus3 ml-1"></i>
            </a>
          </li>
        </ul>
      </portal>
      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="filter-card card card-collapsed">
            <div class="card-header header-elements-inline">
              <h5 class="card-title">{{ this.$t('event.components.participants.navbar.filterRecord') }}</h5>

              <div class="header-elements">
                <div class="list-icons">
                  <el-button-group>
                    <el-button size="mini" @click="$store.state.surveys.filter.searchTerm = ''" round>{{ t('event.buttons.reset') }}</el-button>
                    <el-button size="mini" type="danger" @click="isFilterEnabled = false" round>{{ t('event.buttons.close') }}</el-button>
                  </el-button-group>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-12">
                  <el-input clearable v-model="$store.state.surveys.filter.searchTerm" :placeholder="$t('event.textbox.filterLabel')"></el-input>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <h5 class="card-title">{{ this.$t('event.menu.surveys.title') }}</h5>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button icon="fas fa-redo-alt" size="mini" @click="$store.dispatch('getSurveys')"></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <PageCountInfo :total="$store.state.surveys.filter.total" :skip="skip" :take="take" />

          <el-table v-loading="$store.state.surveys.loading" ref="multipleTable" :data="$store.state.surveys.items" style="width: 100%">
            <el-table-column property="title" :label="$t('event.table.title')" min-width="150"></el-table-column>
            <el-table-column property="participantCount" :label="$t('event.table.participating')" min-width="150"></el-table-column>
            <el-table-column :label="$t('event.table.onAir')" width="220">
              <template slot-scope="scope">
                <el-switch @change="statusChanged($event, scope.$index)" v-model="$store.state.surveys.items[scope.$index].isActive" :active-text="$t('event.variables.yes')" :inactive-text="$t('event.variables.no')"></el-switch>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('event.table.processes')" width="250" fixed="right">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="$t('event.table.qr')" placement="top">
                  <el-button type="success" icon="fas fa-qrcode" circle size="mini" @click="openQr(scope.row.id)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Widget" placement="top">
                  <el-button style="margin: 0" type="success" icon="el-icon-s-operation" circle size="mini" @click="openWidget(scope.row.id)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.table.statistics')" placement="top">
                  <el-button style="margin: 0" type="warning" icon="el-icon-s-data" circle size="mini" @click="getSurveyStats(scope.row)"></el-button>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.downloadReport')" placement="top">
                  <el-popconfirm :title="$t('createReport')" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.variables.no')" @confirm="downloadReport(scope.row.id)">
                    <el-button type="success" slot="reference" size="mini" circle icon="fas fa-exchange-alt"></el-button>
                  </el-popconfirm>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" :content="$t('event.table.comments')" placement="top">
                  <el-button
                    style="margin: 0"
                    type="success"
                    icon="el-icon-chat-line-round"
                    circle
                    size="mini"
                    @click="
                      $store.state.surveydetails.filter.surveyID = scope.row.id;
                      detailModal = true;
                    "
                  ></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.table.edit')" placement="top">
                  <el-button
                    style="margin: 0"
                    type="primary"
                    icon="fas fa-pen"
                    circle
                    size="mini"
                    @click="
                      updateForm = JSON.parse(JSON.stringify(scope.row));
                      modalVisible = true;
                    "
                  ></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.table.delete')" placement="top">
                  <el-popconfirm @confirm="deleteItem(scope.$index)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                    <el-button slot="reference" type="danger" icon="fas fa-trash" circle size="mini"></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="$t('event.tags.editSurvey')" width="80%">
      <SurveyAddUpdate @deleteMe="deleteItem" @closeMe="modalVisible = false" @itemUpdated="itemUpdated" @itemAdded="itemAdded" :data="updateForm" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="detailModal" :title="$t('event.tags.responsesSurvey')" width="80%">
      <SurveyDetails :key="$store.state.surveydetails.filter.surveyID" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="statVisible" :title="$t('event.tags.statisticsSurvey')" width="80%">
      <SurveyStats :key="statVisible" :data="surveyStatsData" />
    </el-dialog>
  </div>
</template>

<script>
import SurveyDetails from '../../components/SurveyDetails';
import SurveyStats from '../../components/SurveyStats';
import SurveyAddUpdate from '../../components/SurveyAddUpdate';
import axios from 'axios';
import PageCountInfo from '../../components/PageCountInfo';
import $ from 'jquery';
export default {
  metaInfo: {
    title: 'Surveys',
  },
  components: { SurveyAddUpdate, PageCountInfo, SurveyDetails, SurveyStats },
  name: 'Surveys',
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + 'tags',
      detailModal: false,
      statModal: false,
      surveyStatsData: null,
      statVisible: false,
    };
  },
  methods: {
    downloadReport(id) {
      axios.post('survey/export', { id: id }).then((res) => {
        this.$message.success(res.data.alert.message);
      });
    },
    openWidget(id) {
      window.open('https://cdn.holacon.com/widgets/event-survey.html?applicationID=' + this.$store.state.event.event.applicationID + '&eventID=' + this.$store.state.event.event.id + '&surveyID=' + id, '_blank');
    },
    openQr(id) {
      window.open('https://api.holacon.com/v1/Home/GetQRImage/GetQR/' + id, '_blank');
    },
    getSurveyStats(item) {
      axios.post('survey/getstatistics', { id: item.id }).then((res) => {
        this.surveyStatsData = res.data.data.items;
        this.statVisible = true;
      });
    },
    itemUpdated(item) {
      var index = this.$store.state.surveys.items.findIndex((k) => k.id == item.id);
      if (index != -1) {
        this.$store.state.surveys.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch('getSurveys');
    },
    handleSizeChange(take) {
      this.$store.commit('setSurveyTake', take);
    },
    handleCurrentChange(page) {
      $('html, body').animate({ scrollTop: 0 }, 350);
      this.$store.commit('setSurveyPage', page);
    },
    deleteItem(index) {
      this.$store.dispatch('deleteSurvey', { index, context: this });
    },
    statusChanged(value, index) {
      this.$store.dispatch('toggleSurvey', { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit('setSelectedSurveys', items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return 'row-active';
      }
      return 'row-passive';
    },
  },
  mounted() {
    this.$store.dispatch('getSurveys');
  },
  created() {},
  computed: {
    skip() {
      return (this.$store.state.surveys.filter.page - 1) * this.$store.state.surveys.filter.take;
    },
    take() {
      return this.skip + this.$store.state.surveys.items.length;
    },
  },
  watch: {
    '$store.state.surveys.filter.searchTerm': function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch('getSurveys');
      }, 500);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/event/Surveys.vue